import { useSyncExternalStore } from 'react';
import { getLayerStripeWidth } from '@constants/canvas/general';
import {
  getCanvasSize,
  subscribeToCanvasSize,
} from '@hooks/canvas/canvasSize.store';

const useCanvasWidth = () => {
  const { canvasWidth, containerHeight } = useSyncExternalStore(
    subscribeToCanvasSize,
    getCanvasSize,
  );

  return {
    canvasWidth,
    containerHeight,
    stripeWidth: getLayerStripeWidth(canvasWidth),
  };
};

export default useCanvasWidth;
